export default __webpack_public_path__ + "static/we-doing-8ff0da7b0a471b6903372dfc750b918f.png";